import { Button, Grid, Typography } from "@material-ui/core";
import { SaveOutlined } from "@material-ui/icons";
import { Field, useFormikContext } from "formik";
import { TextField } from 'formik-material-ui';
import * as yup from "yup";
import { ChromePicker, ColorResult } from 'react-color';

import { ticketPrioritySchema } from "../TicketPriorityContext";


let TicketPriorityForm = () => {

    type ticketPriority = yup.InferType<typeof ticketPrioritySchema>
    let formProps = useFormikContext<ticketPriority>()


    let handleChangeColor = (color: ColorResult) => {
        var newColor = formProps.values.color;

        if (color?.rgb.a)
            newColor = color.hex + Math.round(color.rgb.a * 255).toString(16);
        else
            newColor = color.hex;

        formProps.setFieldValue('color', newColor);
    }



    return (
        <>
            <Grid container>
                <Grid item xs={8}>
                    <Field
                        component={TextField}
                        name="description"
                        label="Description"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        component={TextField}
                        name="sortOrder"
                        label="Sort Order"
                        variant="outlined"
                        type="number"
                    />
                </Grid>
                <Grid item xs>
                    <Typography style={{ padding: "10px" }}>Color</Typography>
                    <div>
                        <ChromePicker
                            color={formProps.values.color}
                            onChange={handleChangeColor}
                        />
                    </div>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button type="submit" color="secondary" variant="contained">
                        <SaveOutlined />&nbsp;Save
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default TicketPriorityForm;